import { DataFileInterface } from '@systemeio/file-manager'
import { AttachmentFileInterface, UnsavedAttachmentFileInterface } from '../types/email-interface'

export const concatAttachments = (
  prev: Array<AttachmentFileInterface | UnsavedAttachmentFileInterface>,
  newFile: DataFileInterface,
): Array<AttachmentFileInterface | UnsavedAttachmentFileInterface> => {
  const filterPrev = newFile.id ? prev.filter(item => item.file.id !== newFile.id) : prev

  return [...filterPrev, { file: newFile }]
}
